import { SbBlokData } from "@storyblok/js";
import { StoryblokComponent } from "@made-people/grease-storyblok";

type LogoListProps = {
  bloks: SbBlokData[] | undefined;
  maxLogos?: number;
};

export const LogoList = ({ bloks, maxLogos }: LogoListProps) => {
  if (!bloks || bloks.length === 0) {
    return null;
  }

  return bloks.map((component, index) => {
    const blok =
      maxLogos && Array.isArray(component.logos)
        ? { ...component, logos: component.logos.slice(0, maxLogos) }
        : component;

    return <StoryblokComponent key={index} blok={blok} />;
  });
};
